<script lang="ts">
	import type { PointsInfoBannerContent } from '../../domain/points-info-banner/PointsInfoBannerContent.ts';
	import { PointsInfoBannerType } from '../../domain/points-info-banner/PointsInfoBannerType.ts';
	import { pointsInfoSheet } from '../../domain/SheetData.ts';
	import { onMount } from 'svelte';
	import TrackingService from '../../services/tracking/TrackingService.ts';
	import { onViewport } from '../../services/tracking/IntersectionObserver';
	import {
		trackPointsInfoClick,
		trackPointsInfoSeen,
		trackPointsInfoView
	} from '../../services/tracking/PointsInfoBannerTracking.ts';

	let trackingService: TrackingService;

	let { content, type }: { content: PointsInfoBannerContent, type: PointsInfoBannerType }
		= $props();

	const trackClick = () => {
		trackPointsInfoClick(trackingService, type);
	};

	const trackSeen = () => {
		trackPointsInfoSeen(trackingService, type);
	};

	const trackView = () => {
		trackPointsInfoView(trackingService, type);
	};

	const sheetProps = (): string => {
		return JSON.stringify(pointsInfoSheet(content));
	};

	onMount(() => {
		trackingService = new TrackingService();
		trackView();
	});
</script>

<oc-block-v2
	style="--custom-spacing-y: 0px; --custom-spacing-x: 0px;"
	id="points-info-banner"
	data-testid="points-info-banner"
	data-points-info-banner-type={type}
	use:onViewport
	onenterViewport={trackSeen}
>
	<oc-link-v2
		variant="secondary"
		as-button=""
		data-testid="points-info-banner-description"
		onclick={trackClick}
		data-oc-sheet-v1-create={sheetProps()}
	>
		<div class="points-info-banner oc-copy-100">
			<oc-icon-v1 data-testid="icon_otto-up-points" class="oc-mr-100 points-info-banner__icon" aria-hidden="true"
				type="otto-up-points"></oc-icon-v1>

			{@html content.description}
			<oc-icon-v1 size="50" data-testid="icon_otto-info-hint" class="oc-ml-25 points-info-banner__icon"
				aria-hidden="true"
				type="info-hint"></oc-icon-v1>
		</div>
	</oc-link-v2>
</oc-block-v2>

<style lang="scss">
  .points-info-banner {
    display: flex;
    align-items: center;
    cursor: pointer;
    padding: 16px;

    &__icon {
      background-color: var(--oc-semantic-color-text-default)
    }
  }
</style>
